var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame26(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_3199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow-left-1",
    d: "M-1.23978e-05 8.95276C-0.00235271 8.6779 0.104857 8.41243 0.299988 8.2099L3.48899 4.9999L0.299988 1.7899C-0.105155 1.37119 -0.105155 0.726472 0.299988 0.307762C0.488927 0.111424 0.755724 -0.000366211 1.03536 -0.000366211C1.315 -0.000366211 1.5818 0.111424 1.77074 0.307762L5.69474 4.25919C6.10175 4.67638 6.10175 5.322 5.69474 5.73919L1.77449 9.69205C1.58555 9.88838 1.31875 10.0002 1.03911 10.0002C0.759474 10.0002 0.492677 9.88838 0.303738 9.69205C0.108847 9.49081 0.00159883 9.22652 0.00373745 8.95276",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 10,
    fill: "currentColor",
    transform: "matrix(-1 0 0 1 6 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame26);
export default __webpack_public_path__ + "static/media/Frame (26).16309190723c07ee1b11af8cf8c376b1.svg";
export { ForwardRef as ReactComponent };